export const DELAY_CHECKLISTS = 2000;

export const PROGRESS_INTERVAL = 50;
